import $ from 'jquery';
import {ENDERECO_API} from '../../config/constant';
import {decode as base64_decode, encode as base64_encode} from 'base-64';
import {showDuplicateLoginAlert} from '../../components/Auth/DuplicateLoginAlert';

const ajaxDossieEvent = (type, ll, dd, tk, rejectMessage, pp = 'dossieAutomatico') => {
  return new Promise(function (resolve, reject) {
    try {
      $.ajax({
        url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
        type,
        dataType: 'text',
        headers: {
          'Authorization': 'Bearer ' + tk,
        },
        data: {
          pp: base64_encode(pp),
          ll: base64_encode(ll),
          dd: base64_encode(JSON.stringify(dd)),
          tk,
        },
        success: function (data) {
          data = JSON.parse(base64_decode(data));
          resolve([200, data]);
        },
        error: function (xhr, status, error) {
          console.error('Erro AJAX:', {xhr});
          if (xhr?.message === 'erro_auth') {
            showDuplicateLoginAlert();
          }

          reject([400, {message: rejectMessage}]);
        },
      });
    } catch (err) {
      reject([500, {message: 'Server Error'}]);
    }
  });
};

const RestDossieAutomaticoPost = (config) => {
  const usersRt = base64_decode(sessionStorage.getItem(`ddesp`));
  const storage = JSON.parse(usersRt);
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];
  const Arr_ = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();

  switch (caminho) {
    case 'catalogRelatorios':
      return ajaxDossieEvent('POST', 'catalogRelatorios', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost || {}))], token, 'Erro ao carregar catálogo de relatórios');

    case 'salvarDossie':
      return ajaxDossieEvent('POST', 'salvarDossie', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))], token, 'Erro ao salvar dossiê');

    case 'listarDossies':
      return ajaxDossieEvent('POST', 'listarDossies', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify({}))], token, 'Erro ao listar dossiês');

    case 'cfopList':
      return ajaxDossieEvent('POST', 'cfopList', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost || {}))], token, 'Erro ao carregar lista de CFOPs');

    case 'listarHistorico':
      return ajaxDossieEvent('POST', 'listarHistorico', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost || {}))], token, 'Erro ao carregar histórico de execuções');

    case 'solicitarExecucaoManual':
      return ajaxDossieEvent('POST', 'solicitarExecucaoManual', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost || {}))], token, 'Erro ao solicitar execução manual');

    case 'presignArquivo':
      return ajaxDossieEvent('POST', 'presignArquivo', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost || {}))], token, 'Erro ao gerar link de download');

    case 'enviarEmailHistorico':
      return ajaxDossieEvent('POST', 'enviarEmailHistorico', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost || {}))], token, 'Erro ao enviar e-mail do histórico');

    case 'deletarDossie':
      return ajaxDossieEvent('POST', 'deletarDossie', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost || {}))], token, 'Erro ao excluir dossiê');

    default:
      return new Promise((resolve) => resolve([404, {message: 'Rota não encontrada'}]));
  }
};

const RestDossieAutomaticoGet = (config) => {
  const usersRt = base64_decode(sessionStorage.getItem(`ddesp`));
  const storage = JSON.parse(usersRt);
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];
  const acao = config?.params?.dest || '';

  switch (acao) {
    case 'listarDossies':
      return ajaxDossieEvent('POST', 'listarDossies', [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify({}))], token, 'Erro ao listar dossiês');

    default:
      return new Promise((resolve) => resolve([404, {message: 'Rota não encontrada'}]));
  }
};

export {RestDossieAutomaticoPost, RestDossieAutomaticoGet};
